const state = {
  support: {
    email: null,
    link: null,
  },
  editSupport: {
    email: null,
    link: null,
  },
};

const getters = {
  support(state) {
    return state.support;
  },
  editSupport(state) {
    return state.editSupport;
  },
};

const actions = {
  async fetchSupport({ commit }, own = true) {
    const res = await this._vm.$http.get(`/restapi/ui/support?own=${own}`);
    commit("updateSupport", res.data);
  },
  async fetchEditSupport({ commit }, msp_id = null) {
    const res = await this._vm.$http.get(
      msp_id === null
        ? `/restapi/ui/support?own=true`
        : `/restapi/ui/support?own=true&msp_id=${msp_id}`
    );
    commit("updateEditSupport", res.data);
  },
  async updateSupport({ commit }, support, msp_id = null) {
    const res = await this._vm.$http.put(
      msp_id === null
        ? "/restapi/ui/support"
        : `/restapi/ui/support?msp_id=${msp_id}`,
      support
    );
    commit("updateEditSupport", res.data);
  },
  // eslint-disable-next-line no-unused-vars
  async downloadCertificate({ commit }, type) {
    return await this._vm.$http.get(
      `/restapi/certificates/machine/download?type=${type}`
    );
  },
};

const mutations = {
  updateSupport(state, { email, link }) {
    state.support = {
      email,
      link,
    };
  },
  updateEditSupport(state, { email, link }) {
    state.editSupport = {
      email,
      link,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
